import { LoadingIcon } from '@prosolve/common-components-ui'
import { AgGridReact } from 'ag-grid-react';
import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community'; 
import moment from 'moment';

// Register all Community features
ModuleRegistry.registerModules([AllCommunityModule]);

export default ({
  isLoading,
  filterValues = {},
  analyticsData = {},
}) => {
  const {
    classListData = []
  } = analyticsData;

  const {
    accountId = ''
  } = filterValues;

  const columnDefsRaw = [
    { field: 'questCode', headerName: 'Class Code' },
    { field: 'name', headerName: 'Class Name' },
    { field: 'gradeLevel', headerName: 'Grade' },
    { field: 'email', headerName: 'Email' },
    { field: 'season', headerName: 'Season' },
    { field: 'episode', headerName: 'Episode' },
    { 
      field: 'lastPlayed', 
      headerName: 'Last Played', 
      valueFormatter: (params) => {
        const dateTime = moment(params.value);
        return dateTime.isValid() ? dateTime.format('MM/DD/YY h:mm:ss A') : '';
      } 
    },
    { field: 'studentPreAssessmentCount', headerName: 'Total Pre Assessments Complete' },
    { field: 'studentPostAssessmentCount', headerName: 'Total Post Assessments Complete' },
    { field: 'completedPreAssessment', headerName: 'Facilitator Completed Pre Assessment' },
    { field: 'completedPostAssessment', headerName: 'Facilitator Completed Post Assessment' },
  ];

  // Add on the tooltipFields and headerTooltip since they are just dups of the the field and header name
  const staticColMapFn = col => {
    return { ...col, tooltipField: col.field, headerTooltip: col.headerName }
  }

  const columnDefs = columnDefsRaw.map(staticColMapFn)

  if (isLoading) {
    return (
      <div style={{
        marginTop: '100px',
        flex: 1,
        display: 'flex',
        justifyContent: 'center'
      }}>
        <LoadingIcon />
      </div>
    )
  } else if (!accountId) {
    return (
      <div style={{
        marginTop: '100px',
        flex: 1,
        display: 'flex',
        justifyContent: 'center'
      }}>
        <div>
          {'District Selection is Required to show Class List'}
        </div>
      </div>
    )
  } else {
    return (
      <div style={{ width: '100%', height: 'calc(100vh - 225px)' }}>
        <AgGridReact
          columnDefs={columnDefs}
          rowData={classListData}
          defaultColDef={{ sortable: true, resizable: true, filter: true, tooltipComponent: 'agTooltipComponent' }}
          tooltipShowDelay={300}
          tooltipShowMode={"whenTruncated"}
          enableCellTextSelection={true}
        />
      </div>
    )
  }
}